export default __webpack_public_path__ + "static/media/shadow.924eb486.png";